import { Select } from "antd";
import { type FC, useState } from "react";
import { useTranslation } from "react-i18next";

import { ValidationType } from "../../../../../components/Form/types/types";
import { SelectInput } from "../../../../../components/Select/SelectInput";

interface ValidationSelectorBooleanProps {
    onSelect: Function;
}

type Option = { label: string; value: string };

export const ValidationSelectorRequired: FC<ValidationSelectorBooleanProps> = ({ onSelect }) => {
    const [selectedValue, setSelectedValue] = useState<string>();

    const { t } = useTranslation();

    const onValueChange = (selected: string) => {
        onSelect(selected);
        setSelectedValue(selected);
    };

    const options: Option[] = [
        {
            label: t("enum.validationType.required"),
            value: ValidationType.VALIDATION_REQUIRED,
        },
    ];

    return (
        <SelectInput key={`${selectedValue}`} placeholder={t("appConfigs.validationType")} onChange={onValueChange} value={selectedValue}>
            {options.map((option: Option) => {
                return (
                    <Select.Option key={option.label} value={option.value} displayName={option.label}>
                        {option.label}
                    </Select.Option>
                );
            })}
        </SelectInput>
    );
};
